// extracted by mini-css-extract-plugin
var _1 = "rx11o";
var _2 = "hRPuJ";
export { _1 as "base", _2 as "defaultHint" }
